export default "__VITE_ASSET__Dz2IGEpr__"